import { createStyles } from "src/styles/theme";

export type StylesClasses = keyof typeof styles;

const styles = createStyles({
  container: {
    background: "custom.background.body",
    minHeight: "100vh",
    width: "100%",
    display: "flex",
  },
  outletContainer: {
    padding: "24px",
  },
  outletWrapper: {
    width: "100%",
  },
});

export default styles;
